import { jsx as _jsx } from "react/jsx-runtime";
import { useAppDispatch } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
//import { zigbeeOn } from '../actions/ZigbeeOn';
import { zigbeeOff } from '../actions/ZigbeeOff';
import * as LWIcon from '../components/LWIcon';
export const DeviceButtonsGaragePort = props => {
    const dispatch = useAppDispatch();
    /*
    type StateType = Parameters<typeof DeviceButton2>[0]['state']
    let s1: StateType, s2: StateType;

    if (attrVal?.value == '1') {
        s1 = undefined;
        s2 = 'on';
    }
    else if (attrVal?.value == '0') {
        s1 = 'off';
        s2 = undefined;
    }
    else {
        s1 = undefined;
        s2 = undefined;
    }
*/
    const s1 = undefined;
    return (_jsx("div", { className: "transmitter-buttons lw-button-group", children: _jsx(DeviceButton2, { state: s1, onClick: () => dispatch(zigbeeOff(props.node_id, props.endpoint_id)), children: _jsx(LWIcon.GarageClosed, {}) }) }));
};
